module.exports = __webpack_public_path__ + "static/img/newsbg.6b04857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newsbg.png
// module id = s9J6
// module chunks = 1